import type { ProductPageQueryVariables, ProductPageQuery } from 'src/types';
import query from '../query.graphql';
import { usePageQuery } from 'src/hooks/use-page-query';

export function useProductPageQuery(variables: ProductPageQueryVariables) {
  return usePageQuery<ProductPageQuery>({
    query,
    routeName: 'product',
    variables,
    keepPreviousData: false,
  });
}
